import { useNavigate } from "react-router-dom";
import { Card, Button, Col, Row, Container } from "react-bootstrap";


/*
PROPS
mode={props.mode} partecipante={props.partecipante}
titolo={"Rispondi anche tu!"}
descrizione={"Rispondi ai sondaggi per aiutare il comune a conoscere meglio."}
                                        data={dayjs().subtract(3, 'day').format("DD/MM/YYYY")}
                                        img={seg1}
*/
export default function CartaInizialeSondaggi(props) {
    const navigate = useNavigate();

    const goToPath = (path) => (event) => {
        event.stopPropagation();
        navigate(path);
    };

    return (
        <>
           <Card
  className="cartaSommarioBorder me-3"
  border="secondary"
  style={{ minHeight: "30vh", minWidth: "30vh", height:"300px" }} >

                <Card.Body className='d-flex flex-column justify-content-start'>

                    <Row className='align-items-center'>
                        <Col className="pe-0 text-center">
                            <h5 ><strong>{props.titolo}</strong></h5>
                            <p className="text-center mt-auto">{props.descrizione}</p>     
                        </Col>
                        <Col>
                            <Card.Img className="m-auto mt-4 mb-4" variant="top" src={props.img} />
                        </Col>
                    </Row>    
                          </Card.Body>
            </Card >
        </>
    )
}

{/*
    CARD CON FOOTER:
export default function CartaInizialeSondaggi(props) {
    const navigate = useNavigate();

    const goToPath = (path) => (event) => {
        event.stopPropagation();
        navigate(path);
    };

    return (
        <Card 
            className="cartaSommarioBorder d-flex flex-column justify-content-between" 
            border="secondary"
            style={{ height: "300px", display: "flex" }}
        >
            <Card.Body className='d-flex flex-column justify-content-start flex-grow-1'>
                <Row className='align-items-center'>
                    <Col className="pe-0 text-center">
                        <h4 className="fw-bold m-0">{props.titolo}</h4> 
                    </Col>
                    <Col className="d-flex justify-content-center">
                        <Card.Img 
                            className="m-auto mt-1"  // Ridotto margine per non occupare troppo spazio
                            variant="top" 
                            src={props.img} 
                            style={{ maxWidth: "120px", height: "auto" }} // ⬆ Immagine più grande
                        />
                    </Col>
                </Row>

                <p className="text-center fs-6 mt-2">{props.descrizione}</p> 
            </Card.Body>

            <Card.Footer className="mt-auto text-center" style={{ padding: "10px" }}>
                <Button variant="primary" className="px-4" onClick={goToPath("/esplora-sondaggi")}>
                    {props.mode === "sondaggio" && "Scopri i sondaggi"}
                </Button>
            </Card.Footer>
        </Card>
    );
}
    */}